import fetch from "auth/FetchInterceptor"

const SupportCoursesService = {}

const supportCoursesPrefix = "/supportCourses"

SupportCoursesService.getSupportCourses = async () =>
  await fetch(`${supportCoursesPrefix}/`, {
    method: "GET",
  })

SupportCoursesService.getSupportCourse = async (id) =>
  await fetch(`${supportCoursesPrefix}/${id}`, {
    method: "GET",
  })

SupportCoursesService.createSupportCourse = async (formData) =>
  await fetch(`${supportCoursesPrefix}/`, {
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })

// Endpoint pour valider un cours de soutien
SupportCoursesService.validateSupportCourse = async (id) =>
  await fetch(`${supportCoursesPrefix}/${id}/validate`, {
    method: "PATCH",
  })

// Endpoint pour rejeter un cours de soutien
SupportCoursesService.rejectSupportCourse = async (id, reason) =>
  await fetch(`${supportCoursesPrefix}/${id}/reject`, {
    method: "PATCH",
    data: { reason },
  })

SupportCoursesService.updateSupportCourse = async (id, data) =>
  await fetch(`${supportCoursesPrefix}/${id}`, {
    method: "PATCH",
    data,
  })

// Remplace le formateur du cours de soutien (le modèle n'a qu'un seul champ instructor)
SupportCoursesService.assignInstructor = async (id, instructorId) =>
  await fetch(`${supportCoursesPrefix}/${id}/instructor`, {
    method: "PATCH",
    data: { instructorId },
  })

SupportCoursesService.deleteSupportCourse = async (id) =>
  await fetch(`${supportCoursesPrefix}/${id}`, {
    method: "DELETE",
  })

SupportCoursesService.addStudents = async (id, data) =>
  await fetch(`${supportCoursesPrefix}/${id}/students`, {
    method: "POST",
    data,
  })

SupportCoursesService.deleteStudent = async (id, data) =>
  await fetch(`${supportCoursesPrefix}/${id}/students`, {
    method: "DELETE",
    data,
  })

SupportCoursesService.getStudentSupportCourses = async (id) =>
  await fetch(`${supportCoursesPrefix}/${id}/students`, {
    method: "GET",
  })

SupportCoursesService.getStudentSupportCourse = async (
  id,
  studentSupportCourseId,
) =>
  await fetch(
    `${supportCoursesPrefix}/${id}/students/${studentSupportCourseId}`,
    {
      method: "GET",
    },
  )

SupportCoursesService.getStudentSupportCourseForSupportCourse = async (
  supportCourseId,
  groupId,
) =>
  await fetch(
    `${supportCoursesPrefix}/${supportCourseId}/studentSupportCourses`,
    {
      method: "GET",
      params: {
        groupId,
      },
    },
  )

// ✅ Nouvelle méthode pour ajouter des sessions new
SupportCoursesService.addSessionsToStudentSupportCourse = async (data) =>
  await fetch(`${supportCoursesPrefix}/add-sessions`, {
    method: "POST",
    data,
  })

export default SupportCoursesService
